import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { BaseFieldComponent } from '../base-field.component';
import * as _ from 'lodash';
import { NA_VALUE } from 'src/app/constants';
import { IBaseTable } from 'src/app/interfaces/calibration-set-table.interface';

@Component({
    standalone: false,
    selector: 'ziq-number-na-value-field',
    templateUrl: './number-na-value-field.component.html',
    styleUrls: ['./number-na-value-field.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush

})
export class NumberNaValueFieldComponent extends BaseFieldComponent {
    @HostBinding('class')
    readonly hostClass = 'ziq-number-na-value-field';

    @Input()
    table: IBaseTable;

    get isNAValue(): boolean {
        return this.currentDisplayedValue === NA_VALUE;
    }

    get isDisabled(): boolean {
        return !this.fieldSettings || this.fieldSettings.isNABlocked || this.readOnly;
    }

    get currentValue() {
        return this.modelValue?.currentState?.[this.property];
    }

    onCurrentValueChange(value: unknown) {
        if (this.modelValue?.currentState) {
            this.modelValue.currentState[this.property] = value;
        }
    }

    setZeroFieldValue() {
        this.modelValue.setCurrentStateValue(this.property, null);
        this.fieldSettings.detectGlobalChanges(this.table);
        this.syncService.emitValueChanged(this);
    }

    setNAFieldValue() {
        this.modelValue.setCurrentStateValue(this.property, NA_VALUE);
        this.fieldSettings.detectGlobalChanges(this.table);
        this.syncService.emitValueChanged(this);
    }

    handleValueChange() {
        super.handleValueChange();
        this.fieldSettings.detectGlobalChanges(this.table);
    }
}
